import { SelectWithField } from 'components/Selects/Select';
import { translations } from 'new/form/common/types';
import { useTranslations } from 'utils/hooks/useTranslations';

import { useGetFoundingMonthOptions } from './useGetFoundingMonthOptions';

type Props = {
  name: string;
  optional?: boolean;
};

export const FoundingMonthSelect = ({ name, optional = false }: Props) => {
  const options = useGetFoundingMonthOptions();
  const t = useTranslations();

  return (
    <SelectWithField
      name={name}
      options={options}
      placeholder={t(translations.placeholders.pleaseChoose)}
      data-testid={'select-field-founding-month'}
      optional={optional}
    />
  );
};
